import { StorageManager } from "datastake-daf/src/helpers/StorageManager";

export const isProxy = () => {
  const pathname = window.location.pathname;
  if (pathname.includes('/proxy/pme') || pathname.includes('/proxy/cadd')) {
    return window.opener || !!StorageManager.get('proxy_token');
  }

  return false;
};

export const getToken = () =>
  isProxy() ? StorageManager.get('proxy_token') : StorageManager.get('token');
